import React from 'react';
import messages_en from "../en/messages_en.mjs";


const goalTypesBuilderKey = 'goalTypes';


const renderCardTrigger = (builderKey, cardKey) => {
  const iconPath = messages_en[`${builderKey}.${cardKey}.icon`];
  const title = messages_en[`details.${builderKey}.${cardKey}`];

  return (
    <div className={`viewCardTrigger option-${cardKey}`}>
      <div className='viewCardTrigger__icon'>
        <img src={iconPath} />
      </div>
      <div className='viewCardTrigger__title'>{ title }</div>
    </div>
  )
};


export default {
  'goalTypes.goals_homePurchase': renderCardTrigger(goalTypesBuilderKey, 'goals_homePurchase'),
  'goalTypes.goals_homeBuild': renderCardTrigger(goalTypesBuilderKey, 'goals_homeBuild'),
  'goalTypes.goals_homeImprovement': renderCardTrigger(goalTypesBuilderKey, 'goals_homeImprovement'),
  'goalTypes.goals_vehiclePurchase': renderCardTrigger(goalTypesBuilderKey, 'goals_vehiclePurchase'),
  'goalTypes.goals_creditCard': renderCardTrigger(goalTypesBuilderKey, 'goals_creditCard'),
  'goalTypes.goals_debtConsolidation': renderCardTrigger(goalTypesBuilderKey, 'goals_debtConsolidation'),
  'goalTypes.goals_healthcare': renderCardTrigger(goalTypesBuilderKey, 'goals_healthcare'),
  'goalTypes.goals_lifeEvent': renderCardTrigger(goalTypesBuilderKey, 'goals_lifeEvent'),
};